const TriggerResponsible = {
  fields: [
    { 
      key: 'userName',
      label: "Envolvido", 
      sortable: true 
    },
    { 
      key: 'workshifta',
      label: "Turno A",  
      sortable: true,
    },
    { 
      key: 'workshiftb',
      label: "Turno B", 
      sortable: true 
    },
    { 
      key: 'workshiftc',
      label: "Turno C", 
      sortable: true,
    },
    { 
      key: "alwayssend", 
      label: "Sempre", 
      sortable: true 
    }
  ],
}

export default TriggerResponsible